import { IBrandOnboardContent } from '../../common/view-model';
const DEFAULT_STATE: IBrandPageModel = {
	firstTimeComponentProps: {
		id: 'first-time',
		title: 'First time exhibiting at Expo or uploading products to Beacon Discovery',
		description:
			'Includes those who exhibited at NN ‘24 or EW ‘25 with no products on Beacon Discovery.',
		active: false
	},
	needChangesComponentProps: {
		id: 'need-changes',
		title: 'Brand with existing products on Beacon Discovery that require updates',
		description: 'For brands that already have products on Beacon Discovery.',
		active: false
	},
	beaconOnlyComponentProps: {
		id: 'beacon-only-brand',
		title: 'Beacon Discovery-only brands not participating in Expo events',
		description: 'For those brands applying to be on Beacon Discovery only. ',
		active: false
	}
};
interface IBrandContentProps extends Omit<IBrandOnboardContent, 'content'> {}
interface IBrandPageModel {
	firstTimeComponentProps: IBrandContentProps;
	needChangesComponentProps: IBrandContentProps;
	beaconOnlyComponentProps: IBrandContentProps;
}
export const BrandOnboardPageModel = {
	...DEFAULT_STATE
};
